import Vue from "vue";
import AppConfig from "@TestRideEvent/Scripts/Config/AppConfig";
import { router } from "@TestRideEvent/Scripts/Config/RouteConfig";
import { store } from "@TestRideEvent/Scripts/Config/StoreConfig";
import StyleHelper from "@Scripts/Infrastructure/StyleHelper";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Account", "PrivacyPolicy"]
        });

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
            }
        });

        (<any>window).App.instances.vm = vm;

        StyleHelper.resetCssAnimations();
    }
}